import React, { useEffect } from "react";
import "./Account.scss";
import BurgerMenu from "../../../components/BurgerMenu/BurgerMenu";
import Profile from "../../../components/Profile/Profile";
import { editUser } from "../../../http/userAPI";
import { getUserOperation as getUser } from "../../../store/user/operations";
import { getUserSelector } from "../../../store/user/selectors";
import { useSelector, useDispatch } from "react-redux";
import Container from "../../../components/Container/Container";
import { useMessageSuccess } from "../../../hooks/message.hook";


const Account = () =>  {
  const messageSuccess = useMessageSuccess();
  const dispatch = useDispatch();
  const user = useSelector(getUserSelector); 
  const editSelfInfo = (values) => editUser(values).then(res => {
    if(res.status) {
      messageSuccess(res.data);
      dispatch(getUser())
    }
  })
  useEffect(() => {
    dispatch(getUser())
  },[])
  
  return (
    <>
    <Container>
      <section className="form__container">
        <h1>Account</h1>
        <BurgerMenu/>
        <Profile user={user} editSelfInfo={editSelfInfo}/>
      </section>
    </Container>
    </>
  );
}

export default Account;